import { render } from "./SectionHeading.vue?vue&type=template&id=6b642ae9&scoped=true"
import script from "./SectionHeading.vue?vue&type=script&lang=js"
export * from "./SectionHeading.vue?vue&type=script&lang=js"

import "./SectionHeading.vue?vue&type=style&index=0&id=6b642ae9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b642ae9"]])

export default __exports__